import { render } from "./LegalContent.vue?vue&type=template&id=14d0e442&scoped=true"
const script = {}

import "./LegalContent.vue?vue&type=style&index=0&id=14d0e442&scoped=true&lang=scss"

import exportComponent from "/Volumes/Quoicoubeh/Paraleclypse/website/paraleclypse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14d0e442"]])

export default __exports__